<template>
  <div class="leading-normal">
    <h3 class="text-xl mb-6 pb-4 border-b"><i class="fas fa-truck mr-2 text-lg text-print-order-teal" /> Delivery</h3>
    <div v-if="requiresDeliveryAddress">
      <p class="text-sm mb-6">Please confirm the delivery address for your order.</p>
      <delivery-address-list @change="updateDeliveryAddress" @updateAddress="updateDeliveryAddress" :value="deliveryAddressId" :deliveryAddresses="deliveryAddresses" />
      <!-- Phone Number Field -->
    <div class="flex flex-wrap -mx-2 mt-6 mb-4">
      <div class="w-full md:w-1/2 px-2">
        <h4 class="mb-2 text-xs">Phone Number: *</h4>
        <input
          type="text"
          v-model="phoneNumber"
          class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3"
          @input="emitPhoneNumber(phoneNumber)"
        />
      </div>
    </div>
    </div>
    <p v-else class="text-sm mb-6">This order will be delivered digitally and does not require a physical delivery address.</p>

    <h3 class="mt-6 pt-6 border-t mb-2 text-sm">Notifications:</h3>
    <p>We will keep you updated on your order by sending email notifications to {{ profile.email }}. To send these notifications to more recipients, enter CC email addresses below.</p>
    <div class="flex flex-wrap -mx-2 mt-6 mb-2">
      <div class="w-full md:w-1/2 px-2">
        <h4 class="mb-2 text-xs">New Recipient:</h4>
        <div class="flex">
          <input type="email" v-model="ccEmail" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" @keyup.enter="$emit('addCc', ccEmail); ccEmail = null" />
          <button class="bg-grey-lighter hover:bg-grey-light border-t border-r border-b px-3" @click="$emit('addCc', ccEmail); ccEmail = null">Add</button>
        </div>
      </div>

      <div class="w-full md:w-1/2 px-2">
        <h4 class="mb-2 text-xs">CC Addresses:</h4>
        <em v-if="notificationCc.length === 0">
          No other recipients
        </em>
        <table class="w-full">
          <tbody>
            <tr v-for="(recipient, i) in notificationCc" :key="i">
              <td>{{ recipient }}</td>
              <td class="text-right py-2">
                <i class="fas fa-times-circle text-grey-dark hover:text-grey-darkest cursor-pointer" title="Remove" @click="$emit('removeCc', recipient)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DeliveryAddressList from '@/components/DeliveryAddressList'
import { mapState } from 'vuex'
export default {
  components: { DeliveryAddressList },
  data () {
    return {
      name: 'Custom Print Order',
      addressModalOpen: false,
      ccEmail: null,
      phoneNumber: ''
    }
  },
  mounted () {
    // Emit the initial phone number when the component is mounted
    this.emitPhoneNumber(this.phoneNumber)
  },
  props: ['deliveryAddressId', 'deliveryAddress', 'deliveryAddresses', 'requiresDeliveryAddress', 'notificationCc'],
  computed: {
    ...mapState(['profile'])
  },
  created () {
    this.phoneNumber = this.profile.mobile || ''
  },
  methods: {
    updateDeliveryAddress ($event) {
      this.$emit('updateAddress', $event)
    },
    emitPhoneNumber (phoneNumber) {
      // Emit the updated phone number to the parent
      this.$emit('updatePhoneNumber', phoneNumber)
    }
  }
}
</script>
